import Component from '../abstracts/Component';
import SelectComponent from "./SelectComponent";


export default class BridalWeddingAppointmentComponent extends Component {

  get SELECTORS() {
    return {
      main: ".js-wedding-appointment",
      cta: ".js-wedding-appointment-cta",
      textTab: ".js-wedding-appointment-text-tab",
      formTab: ".js-wedding-appointment-form-tab",
      form: ".js-wedding-appointment-form",
      selectStore: ".js-wedding-appointment-select-store",
      selectTime: ".js-wedding-appointment-select-time",
      bridalData: ".bridalMobileSm",
      bridalNote: ".textbridalMobileSm",
      submit: ".js-wedding-appointment-submit",
      submitWrapper: ".js-wedding-appointment-submit-wrapper",
      success: ".js-wedding-appointment-success",
      successEmail: ".js-wedding-appointment-success-email",
      successName: ".js-wedding-appointment-success-name",
      bookCta: ".js-wedding-appointment-book-cta",
      bookConfirm: ".js-wedding-appointment-book-confirm",
      privacyLabel: ".js-wedding-appointment-privacy-label",
      collapse: ".js-wedding-appointment-collapse" /* [0] => Store Collapse, [1] => time Collapse, [2] => data collapse */
    }
  }

  constructor() {
    super();
  }

  bindEvents() {
    const components = document.querySelectorAll(this.SELECTORS.main);

    components.forEach(comp => {
      let callToActions = comp.querySelectorAll(this.SELECTORS.cta);

      callToActions.forEach(cta => {
        cta.addEventListener("click", e => {
          e.preventDefault();

          let elementList = [];

          elementList.push(comp.querySelectorAll(this.SELECTORS.textTab)[0]); // Component is design for having only one text tab
          elementList.push(comp.querySelectorAll(this.SELECTORS.formTab)[0]); // Component is design for having only one form tab

          elementList.forEach(element => {
            element.classList.toggle("hidden");
          })
        })
      });

      let privacyLabel = comp.querySelectorAll(this.SELECTORS.privacyLabel);
      let submit = comp.querySelectorAll(this.SELECTORS.submit);

      privacyLabel.forEach(label => {
          label.addEventListener("click", e => {
            submit[0].disabled = !submit[0].disabled;
          });
      });

      let selectStore = comp.querySelectorAll(this.SELECTORS.selectStore),
        selectTime = comp.querySelectorAll(this.SELECTORS.selectTime);

      selectStore.forEach(select => {
        $(select).on("change", (e) => {

          let str = "";
             str += $( select ).val();

          let data = {"storeName": str}; // retrieve selected options value

          $.ajax({
            type: "GET",
            contentType: "application/json",
            dataType: 'json',
            url: "/booking-tool?get-time=true",
            data: data,
            cache: false,
            success: (response) => {
              if (response.hasError) {
                console.log("Error during ajax call");
                return;
              }


              selectTime.forEach(select => {
                let options = [];
                // create new select options using the response data
                response.timeSlots.forEach(timeSlot => {
                  options.push(new Option(timeSlot, timeSlot, false, false));
                });

                // clear previous options and had empty option for show placeholder
                select.innerHTML = "<option></option>";

                // add new options to the select
                options.forEach(newOption => {
                  $(select).append(newOption).trigger('change');
                });
              })
            },
            error: function (errorObj, textStatus, errorThrown) {
              console.log("Error: " + errorObj + " status: " + textStatus + "thrown: " + errorThrown);
            }
          });

          comp.querySelectorAll(this.SELECTORS.collapse)[1].click();
        });
      });

      selectTime.forEach(select => {
        $(select).on("change", (e) => {
           if ($(select).val()) {
             comp.querySelectorAll(this.SELECTORS.collapse)[2].click();
             //comp.querySelectorAll(this.SELECTORS.submitWrapper)[0].classList.toggle("hidden");
           }
        })
      });

      let forms = comp.querySelectorAll(this.SELECTORS.form);

      forms.forEach(form => {

        submit.forEach(btn => {
          btn.addEventListener("click", e => {
            e.preventDefault();
            const domEvent = document.createEvent('Event');
            domEvent.initEvent('submit', false, true);
            form.dispatchEvent(domEvent)
          })
        });

        form.addEventListener("submit", e => {
          e.preventDefault();
          if(BridalWeddingAppointmentComponent.validateForm(form)) {

            let formData = new FormData(form),
              data = {};
            comp.querySelectorAll(this.SELECTORS.submit)[0].classList.add("disabled");

            formData.forEach((value, key) => {
              data[key] = value
            });

            data.isPrivacy = data.isPrivacy === "on";
            data.isNewsletter = data.isNewsletter === "on";

            $.ajax({
              type: "POST",
              contentType: "application/json",
              dataType: 'json',
              url: "/booking-tool?book-appointment=true",
              data: JSON.stringify(data),
              cache: false,
              success: (response) => {
                if (response.hasError) {
                  //TODO: show frontend error
                  return;
                }
                comp.querySelectorAll(this.SELECTORS.successName)[0].innerHTML = data.name;
                comp.querySelectorAll(this.SELECTORS.successEmail)[0].innerHTML = data.email;

                //comp.querySelectorAll(this.SELECTORS.bookCta)[0].classList.remove("hidden");
                comp.querySelectorAll(this.SELECTORS.bookConfirm)[0].classList.remove("hidden");
                comp.querySelectorAll(this.SELECTORS.submit)[0].classList.add("disabled");
                comp.querySelectorAll(this.SELECTORS.success)[0].classList.remove("hidden");// Component is design for having only one success area
                comp.querySelectorAll(this.SELECTORS.bookCta)[0].classList.add("hidden");
                comp.querySelectorAll(this.SELECTORS.collapse)[2].click();
                comp.querySelectorAll(this.SELECTORS.selectStore)[0].setAttribute("disabled", "");
                comp.querySelectorAll(this.SELECTORS.selectTime)[0].setAttribute("disabled", "");

                comp.querySelectorAll(this.SELECTORS.bridalData)[0].setAttribute("style","border: 1px solid #000000 !important");
                comp.querySelectorAll(this.SELECTORS.bridalData)[0].setAttribute("disabled", "");
                comp.querySelectorAll(this.SELECTORS.bridalData)[1].setAttribute("style","border: 1px solid #000000 !important");
                comp.querySelectorAll(this.SELECTORS.bridalData)[1].setAttribute("disabled", "");
                comp.querySelectorAll(this.SELECTORS.bridalData)[2].setAttribute("style","border: 1px solid #000000 !important");
                comp.querySelectorAll(this.SELECTORS.bridalData)[2].setAttribute("disabled", "");
                comp.querySelectorAll(this.SELECTORS.bridalData)[3].setAttribute("style","border: 1px solid #000000 !important");
                comp.querySelectorAll(this.SELECTORS.bridalData)[3].setAttribute("disabled", "");
                comp.querySelectorAll(this.SELECTORS.bridalData)[4].setAttribute("style","border: 1px solid #000000 !important");
                comp.querySelectorAll(this.SELECTORS.bridalData)[4].setAttribute("disabled", "");
                comp.querySelectorAll(this.SELECTORS.bridalData)[5].setAttribute("style","border: 1px solid #000000 !important");
                comp.querySelectorAll(this.SELECTORS.bridalData)[5].setAttribute("disabled", "");

                comp.querySelectorAll(this.SELECTORS.bridalNote)[0].setAttribute("style","border: 1px solid #000000 !important");
                comp.querySelectorAll(this.SELECTORS.bridalNote)[0].setAttribute("disabled", "");

              },
              error: function (errorObj, textStatus, errorThrown) {
                console.log("Error: " + errorObj + " status: " + textStatus + "thrown: " + errorThrown);
              }
            });
          }
        });
      })
    })

    let test = new SelectComponent();
    test.loadAndInit();

  }

  static validateForm(form){
    let inputs = form.querySelectorAll("input"),
        error = false;
    inputs.forEach(input => {
      if( input.checkValidity() ){input.classList.remove = 'error';}
      else{
        $(input).addClass("error");
        error = true;
      }
    });
    return !error;
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) this.bindEvents();
  }

}
